"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateWeightedAverageConcentrationLimitKickouts = exports.calculateWeightedAverageReceivableKickouts = void 0;
const common_1 = require("@finley-technologies/common");
const bruteForce = __importStar(require("./bruteForce"));
const greedy = __importStar(require("./greedy"));
const WeightedAverageReceivable_1 = require("./WeightedAverageReceivable");
// given WeightedAverageReceivable's generates kickouts.
// this is used directly by pointer methods when
// weighting is not standard.
const calculateWeightedAverageReceivableKickouts = ({ receivables, concentrationLimit, limitType, waConcentrationLimitSolver, }) => {
    const startingWeightedAverage = common_1.utils.calculateWeightedAverage(receivables);
    let kickouts = {};
    switch (waConcentrationLimitSolver) {
        case 'greedy':
            kickouts = greedy.calculateWeightedAverageConcentrationLimitKickouts({
                receivables,
                limitType,
                concentrationLimit,
            });
            break;
        case 'bruteForce':
            kickouts = bruteForce.calculateKickouts({
                receivables,
                limitType,
                concentrationLimit,
            });
            break;
        default:
            (0, common_1.finleyAssertUnreachable)(waConcentrationLimitSolver);
    }
    return {
        kickouts,
        calculations: {
            concentrationLimit,
            concentration: startingWeightedAverage,
        },
    };
};
exports.calculateWeightedAverageReceivableKickouts = calculateWeightedAverageReceivableKickouts;
// given concentrationReceivables, 1st generates WeightedAverageReceivable's then
// computs kickouts.
const calculateWeightedAverageConcentrationLimitKickouts = ({ concentrationReceivables, field, concentrationLimit, limitType, weighting, propertyKey, }) => {
    const receivables = (0, WeightedAverageReceivable_1.makeWeightedAverageReceivables)({
        concentrationReceivables,
        weighting,
        field,
    });
    // TODO - we will need to inspect concentration limit receivables to determine
    // which wasConcentrationLimitSolver to use
    let waConcentrationLimitSolver = 'greedy';
    /**
     * !!!!!!! HACK ALERT !!!!!!!
     * 2023-04-04
     * Arc has a special use case to solve for the exact optimum for one of their
     * concentration limit tests, namely, maximumWaProjectedRecoveryPeriod.
     *
     * We cannot roll this out to GA, as we have not yet reached alignment with
     * borrower+capitalProviders in regard to negative exposure receivable handling.
     * Specifically, an optimized solution will never include a negative receivable in the solution,
     * yet capitalProviders do, so we need to maintain existing greedy algo for general population.
     */
    if (propertyKey === 'maximumWaProjectedRecoveryPeriod') {
        const breachingReceivables = bruteForce.filterBreachingReceivables({
            receivables,
            limitType,
            concentrationLimit,
        });
        if (breachingReceivables.length <=
            common_1.consts.MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT) {
            waConcentrationLimitSolver = 'bruteForce';
        }
    }
    return (0, exports.calculateWeightedAverageReceivableKickouts)({
        receivables,
        concentrationLimit,
        limitType,
        waConcentrationLimitSolver,
    });
};
exports.calculateWeightedAverageConcentrationLimitKickouts = calculateWeightedAverageConcentrationLimitKickouts;
//# sourceMappingURL=index.js.map